<nav class="drtv-nav" [style.position]="sticky ? 'sticky' : 'static'">
  <header>
    <div class="drtv-nav__inner drtv-nav__inner--wide">
      <div class="drtv-nav__flex">
        <a
          [routerLink]="
            '/helpkidstoday/' + this.campaignId + '/' + this.hospitalId
          "
          class="logo-link"
          title="Children's Miracle Network"
        >
          <img
            src="https://resources.childrensmiraclenetworkhospitals.org/cdn/images/cmnh-logos/CMNH_Logo_Primary_RGB.svg"
            alt="CMN Logo"
          />
        </a>

        <app-cmn-button
          class="drtv-nav-donation-button"
          type="button"
          variant="primary"
          title="Donate Now"
          (buttonClick)="scrollToDonate($event)">
          Donate Now
        </app-cmn-button>
      </div>
    </div>
  </header>

  <div class="call-bar">
    <div class="drtv-nav__inner">
      <p>
        You can also donate at
        <br class="drtv-nav__mobile-break"> <a href="{{ 'tel:' + this.phoneNumber }}" title="{{this.phoneNumber}}">{{ this.phoneNumber }}</a
        >.
      </p>
    </div>
  </div>
</nav>
